import React from 'react';

/**
 * Download glyph — ported verbatim from Vue's
 * `src/components/icons/IconDownload.vue`. Used on the order-detail
 * Share Invoice menu's "Download as PDF" item.
 */
interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconDownload: React.FC<IconProps> = ({
  size = 16,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M8 12.088L3.95543 8.04457L4.76457 7.22171L7.42857 9.88571V0H8.57143V9.88571L11.2343 7.22286L12.0446 8.04457L8 12.088ZM1.84686 16C1.32038 16 0.881143 15.824 0.529143 15.472C0.177143 15.12 0.000761905 14.6804 0 14.1531V11.384H1.14286V14.1531C1.14286 14.3291 1.216 14.4907 1.36229 14.6377C1.50857 14.7848 1.66971 14.8579 1.84571 14.8571H14.1543C14.3295 14.8571 14.4907 14.784 14.6377 14.6377C14.7848 14.4914 14.8579 14.3299 14.8571 14.1531V11.384H16V14.1531C16 14.6796 15.824 15.1189 15.472 15.4709C15.12 15.8229 14.6804 15.9992 14.1531 16H1.84686Z"
      fill="currentColor"
    />
  </svg>
);

export default IconDownload;
